<div class="log" [style.minHeight.px]="minScrollHeight" #logContainer>
  <div class="virtual-scroll-container" [style.marginBottom.px]="bottomSpace" #messageContainer>
    <ng-container *ngIf="0 < chatMessages.length">
      <ng-container *ngFor="let chatMessage of chatMessages; trackBy: trackByChatMessage">
        <chat-message *ngIf="chatMessage.isDisplayable" [chatMessage]="chatMessage">
        </chat-message>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="chatMessages.length <= 0">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/0g8eyWd_leI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <chat-message *ngFor="let chatMessage of sampleMessages" [chatMessage]="chatMessage">
      </chat-message>
    </ng-container>
  </div>
</div>
